import React, { useEffect, useState } from "react";
import "./SearchAdditionalInstitutionInput.scss";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import {
  addAddInstitution,
  setResetSearchTextForAdditionalInstitutions,
  setResetSearchTextForCities,
  setSelectedAdditionalInstitutions,
  setSelectedInstitutions,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { useDebounce } from "primereact/hooks";
import { Skeleton } from "primereact/skeleton";

// const initialAdditionalInstitutions = [
//   { value: "alabama", label: "Alabama" },
//   { value: "alaska", label: "Alaska" },
//   { value: "arizona", label: "Arizona" },
//   { value: "arkansas", label: "Arkansas" },
//   { value: "california", label: "California" },
//   { value: "colorado", label: "Colorado" },
//   { value: "connecticut", label: "Connecticut" },
//   { value: "delaware", label: "Delaware" },
//   { value: "florida", label: "Florida" },
//   { value: "georgia", label: "Georgia" },
//   { value: "hawaii", label: "Hawaii" },
//   { value: "idaho", label: "Idaho" },
//   { value: "illinois", label: "Illinois" },
//   { value: "indiana", label: "Indiana" },
//   { value: "iowa", label: "Iowa" },
//   { value: "kansas", label: "Kansas" },
//   { value: "kentucky", label: "Kentucky" },
//   { value: "louisiana", label: "Louisiana" },
//   { value: "maine", label: "Maine" },
//   { value: "maryland", label: "Maryland" },
//   { value: "massachusetts", label: "Massachusetts" },
//   { value: "michigan", label: "Michigan" },
//   { value: "minnesota", label: "Minnesota" },
//   { value: "mississippi", label: "Mississippi" },
//   { value: "missouri", label: "Missouri" },
//   { value: "montana", label: "Montana" },
//   { value: "nebraska", label: "Nebraska" },
//   { value: "nevada", label: "Nevada" },
//   { value: "new_hampshire", label: "New Hampshire" },
//   { value: "new_jersey", label: "New Jersey" },
//   { value: "new_mexico", label: "New Mexico" },
//   { value: "new_york", label: "New York" },
//   { value: "north_carolina", label: "North Carolina" },
//   { value: "north_dakota", label: "North Dakota" },
//   { value: "ohio", label: "Ohio" },
//   { value: "oklahoma", label: "Oklahoma" },
//   { value: "oregon", label: "Oregon" },
//   { value: "pennsylvania", label: "Pennsylvania" },
//   { value: "rhode_island", label: "Rhode Island" },
//   { value: "south_carolina", label: "South Carolina" },
//   { value: "south_dakota", label: "South Dakota" },
//   { value: "tennessee", label: "Tennessee" },
//   { value: "texas", label: "Texas" },
//   { value: "utah", label: "Utah" },
//   { value: "vermont", label: "Vermont" },
//   { value: "virginia", label: "Virginia" },
//   { value: "washington", label: "Washington" },
//   { value: "west_virginia", label: "West Virginia" },
//   { value: "wisconsin", label: "Wisconsin" },
//   { value: "wyoming", label: "Wyoming" },
// ];

export const groupInstitutions = (institutions) => {
  if (institutions != null) {
    const groupedInstitutions = Object.values(
      institutions?.reduce((acc, item) => {
        const firstLetter = item?.label?.[0]?.toUpperCase() ?? "#";

        if (!acc[firstLetter]) {
          if (firstLetter === "#") {
            acc[firstLetter] = { label: `#`, options: [] };
          } else {
            acc[firstLetter] = { label: firstLetter, options: [] };
          }
        }

        if (firstLetter === "#") {
          acc[firstLetter].options.push({
            label: `#${item.value}`,
            value: item.value,
          });
        } else {
          acc[firstLetter].options.push(item);
        }

        return acc;
      }, {}),
    ).sort((a, b) => a.label.localeCompare(b.label));

    // Sort options inside each group
    groupedInstitutions.forEach((group) =>
      group.options.sort((a, b) => a.label.localeCompare(b.label)),
    );
    return groupedInstitutions;
  } else {
    return [];
  }
};

export const sortInstitutions = (institutions) => {
  if (!institutions) return [];
  return [...institutions]?.sort((a, b) => a?.label?.localeCompare(b?.label));
};

const searchInstitutions = (institutions, searchText) => {
  if (!searchText) return institutions;
  const text = searchText?.toLowerCase();
  return institutions.filter((item) =>
    item?.label?.toLowerCase()?.includes(text),
  );
};

const SearchAdditionalInstitutionInput = ({
  isAddRemoveInProgress,
  setIsAddRemoveInProgress,
}) => {
  const dispatch = useDispatch();

  const cohortApplied = useSelector(
    (state) => state?.cohortReducer?.cohortApplied,
  );

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const isFieldsEditiable = useSelector(
    (state) => state?.cohortReducer?.isFieldsEditiable,
  );

  const [institutions, setInstitutions] = useState([]);
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);
  const resetSearchTextForAdditionalInstitutions = useSelector(
    (state) => state?.cohortReducer?.resetSearchTextForAdditionalInstitutions,
  );

  const [inputValue, debouncedValue, setInputValue] = useDebounce("", 400);

  useEffect(() => {
    if (resetSearchTextForAdditionalInstitutions) {
      setInputValue("");
      dispatch(setResetSearchTextForAdditionalInstitutions(false));
    }
  }, [resetSearchTextForAdditionalInstitutions]);

  const selectedAdditionalInstitutions = useSelector(
    (state) => state?.cohortReducer?.selectedAdditionalInstitutions,
  );

  const selectedInstitutions = useSelector(
    (state) => state?.cohortReducer?.selectedInstitutions,
  );

  // const handleSelectedInstitutionChange = (e, fi) => {
  //   if (e.checked) {
  //     dispatch(
  //       setSelectedAdditionalInstitutions([
  //         ...selectedAdditionalInstitutions,
  //         fi,
  //       ]),
  //     );
  //   } else {
  //     dispatch(
  //       setSelectedAdditionalInstitutions(
  //         selectedAdditionalInstitutions?.filter((i) => i?.value !== fi?.value),
  //       ),
  //     );
  //   }
  // };

  useEffect(() => {
    const searchedInstitute = sortInstitutions(
      searchInstitutions(selectedAdditionalInstitutions, debouncedValue),
    );
    setInstitutions(searchedInstitute);
    dispatch(setResetSearchTextForAdditionalInstitutions(false));
  }, [debouncedValue]);

  useEffect(() => {
    setInstitutions(null);
  }, [selectedCohort, cohortApplied]);

  useEffect(() => {
    setTimeout(() => {
      setInstitutions(sortInstitutions(selectedAdditionalInstitutions));
    }, 500);
  }, [selectedAdditionalInstitutions]);

  useEffect(() => {
    let timer;

    if (institutions !== null && institutions.length === 0) {
      timer = setTimeout(() => {
        setShowEmptyMessage(true);
      }, 3000);
    } else {
      setShowEmptyMessage(false);
    }

    return () => clearTimeout(timer);
  }, [institutions]);

  return (
    <div className="search-institution-input-wrapper">
      <div className="select-field">
        <FiSearch className="search-icon" />
        <input
          className="search-input"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Search institutions"
        // disabled={selectedCohort != null}
        />
      </div>

      {/* <div className="option-pannel">
        {institutions?.length > 0 ? (
          institutions?.map((i) => {
            return (
              <div className="group">
                <div className="group-id">{i.label}</div>
                <ul>
                  {i?.options?.map((fi) => {
                    const ids =
                      selectedAdditionalInstitutions?.map((i) => i?.value) ||
                      [];
                    const isChecked = ids?.includes(fi?.value);
                    return (
                      <li
                        key={fi.value}
                        className="fi-selection"
                        onMouseDown={(e) => addSelectedInstitution(e, fi)}
                      >
                        <Checkbox
                          id={fi?.value}
                          name={fi?.label}
                          value={fi?.value}
                          checked={isChecked}
                          onChange={(e) =>
                            handleSelectedInstitutionChange(e, fi)
                          }
                        />
                        <label>{fi?.label}</label>
                        <div
                          className={`add ${selectedCohort != null ? "disabled" : ""}`}
                          onClick={() =>
                            selectedCohort === null &&
                            addInstitutionToCohort(fi)
                          }
                        >
                          <FiPlus />
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })
        ) : (
          <div className="group">
            {showEmptyMessage ? (
              <div className="group-id">No institutions found!</div>
            ) : (
              [...Array(6)].map((_, i) => (
                <div style={{ marginBottom: "1rem" }}>
                  <Skeleton width="100%" height="2rem" />
                </div>
              ))
            )}
          </div>
        )}
      </div> */}
      <div className="option-pannel">
        <div className="group">
          <ul>
            {!isAddRemoveInProgress && institutions?.length > 0 ? (
              institutions?.map((fi) => {
                return (
                  <li key={fi.value} className="fi-selection">
                    <label>{fi?.label}</label>
                    <div
                      className={`add ${!isFieldsEditiable ? "disabled" : ""}`}
                      // className={`add`}
                      onClick={() => {
                        if (!isFieldsEditiable) return;
                        setIsAddRemoveInProgress(true);
                        dispatch(addAddInstitution(fi));
                        dispatch(setResetSearchTextForCities(true));
                      }}
                    >
                      <FiPlus />
                    </div>
                  </li>
                );
              })
            ) : (
              <div className="group">
                {showEmptyMessage ? (
                  <div className="group-id">No institutions found!</div>
                ) : (
                  [...Array(6)].map((_, i) => (
                    <div style={{ marginBottom: "1rem" }}>
                      <Skeleton width="100%" height="2rem" />
                    </div>
                  ))
                )}
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchAdditionalInstitutionInput;
